import { InfoCircle } from '@/components/icons';
import { cn } from '@/lib/utils';

type Props = {
    instructions?: string | null;
    title?: string;
    className?: string;
};

export default function TestApplicationInstructions({
    instructions,
    title = 'Instruções',
    className,
}: Props) {
    if (!instructions?.trim()) return null;

    return (
        <section
            className={cn('rounded-xl border border-brand/15 bg-brand-subtle/60 p-5', className)}
        >
            <div className="mb-3 flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-brand">
                <InfoCircle className="size-4" />
                {title}
            </div>
            <div className="whitespace-pre-line text-sm leading-6 text-foreground">
                {instructions}
            </div>
        </section>
    );
}
